export default "__VITE_ASSET__p3lAhEBy__"